<template>
  <div class="section">
    <div class="section-header">
      <span class="section-number">二</span>
      <span class="section-text">XTS 兼容性测评进展</span>
    </div>
    <div class="xts-row">
      <div class="xts-container">
        <div class="xts-header">
          <div class="xts-header-left">
            <check-circle-outlined class="xts-header-icon" />
            <span class="xts-header-title">7月XTS认证测评概览</span>
          </div>
          <div class="xts-total-badge">
            测评总数 <span class="xts-total-value">260</span> 款
          </div>
        </div>
        <div class="xts-status-row">
          <div class="xts-status-card xts-status-certified">
            <div class="xts-status-header xts-status-header-certified">
              <div class="xts-status-label">已发证</div>
              <div class="xts-status-count">124 <span class="xts-status-unit">款</span></div>
            </div>
            <div class="xts-status-body">
              <div class="xts-sub-item"><span>发行版</span><span class="xts-sub-value xts-sub-value-certified">1款</span></div>
              <div class="xts-sub-item"><span>模组/开发板</span><span class="xts-sub-value xts-sub-value-certified">33款</span></div>
              <div class="xts-sub-item"><span>商用设备</span><span class="xts-sub-value xts-sub-value-certified">90款</span></div>
            </div>
          </div>
          <div class="xts-status-card xts-status-reviewing">
            <div class="xts-status-header xts-status-header-reviewing">
              <div class="xts-status-label">实验室审核中</div>
              <div class="xts-status-count">94 <span class="xts-status-unit">款</span></div>
            </div>
            <div class="xts-status-body">
              <div class="xts-sub-item"><span>发行版</span><span class="xts-sub-value xts-sub-value-reviewing">3款</span></div>
              <div class="xts-sub-item"><span>模组/开发板</span><span class="xts-sub-value xts-sub-value-reviewing">11款</span></div>
              <div class="xts-sub-item"><span>商用设备</span><span class="xts-sub-value xts-sub-value-reviewing">80款</span></div>
            </div>
          </div>
          <div class="xts-status-card xts-status-pending">
            <div class="xts-status-header xts-status-header-pending">
              <div class="xts-status-label">待审核</div>
              <div class="xts-status-count">21 <span class="xts-status-unit">款</span></div>
            </div>
            <div class="xts-status-body">
              <div class="xts-sub-item"><span>模组/开发板</span><span class="xts-sub-value xts-sub-value-pending">12款</span></div>
              <div class="xts-sub-item"><span>商用设备</span><span class="xts-sub-value xts-sub-value-pending">9款</span></div>
            </div>
          </div>
          <div class="xts-status-card xts-status-rejected">
            <div class="xts-status-header xts-status-header-rejected">
              <div class="xts-status-label">驳回</div>
              <div class="xts-status-count">21 <span class="xts-status-unit">款</span></div>
            </div>
            <div class="xts-status-body">
              <div class="xts-sub-item"><span>模组/开发板</span><span class="xts-sub-value xts-sub-value-rejected">2款</span></div>
              <div class="xts-sub-item"><span>商用设备</span><span class="xts-sub-value xts-sub-value-rejected">19款</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="potential-partner-container">
        <div class="potential-partner-title">潜在伙伴单位</div>
        <div ref="potentialPartnerChartRef" class="potential-partner-chart"></div>
      </div>
    </div>
    <div class="xts-reject-container">
      <div class="xts-reject-header">
        <check-circle-outlined class="xts-reject-header-icon" />
        <span class="xts-reject-header-title">7月XTS认证测评被驳回情况</span>
      </div>
      <table class="xts-reject-table">
        <thead>
          <tr>
            <th style="width: 50px;">序号</th>
            <th>企业名称</th>
            <th style="width: 100px;">产品类型</th>
            <th>产品名称</th>
            <th style="width: 170px;">申请时间</th>
            <th style="width: 110px;">停留时长(天)</th>
            <th style="width: 100px;">是否捐赠人</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in xtsRejectData" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ row.company }}</td>
            <td>{{ row.type }}</td>
            <td>{{ row.product }}</td>
            <td>{{ row.time }}</td>
            <td :class="row.duration >= 15 ? 'xts-duration-high' : ''">{{ row.duration }}</td>
            <td>
              <span :class="row.isDonor ? 'xts-donor-yes' : 'xts-donor-no'">{{ row.isDonor ? '是' : '否' }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section-summary">
      <div class="section-summary-title">
        <span class="section-summary-icon"><safety-certificate-outlined /></span>
        XTS 兼容性测评总结
      </div>
      <p>7 月 XTS 测评总提测 260 款，商用设备为申报主力。本月驳回 21 款，多数项目流转周期偏长，流程规范有待加强。狄鸿智创等头部企业持续批量申报，构成业务基本盘。后续将梳理驳回共性问题前置赋能厂商、优化审核时效。</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import * as echarts from 'echarts';
import { CheckCircleOutlined, SafetyCertificateOutlined } from '@ant-design/icons-vue';

const potentialPartnerChartRef = ref(null);
let potentialPartnerChartInstance = null;

const xtsRejectData = [
  { id: 1, company: '北京安控油气技术有限责任公司', type: '商用设备', product: 'Dicome250', time: '2026-07-02 19:00:08', duration: 21.92, isDonor: false },
  { id: 2, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '病房床头机', time: '2026-07-03 14:44:22', duration: 21.02, isDonor: false },
  { id: 3, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '护士站管理机', time: '2026-07-03 09:39:30', duration: 21.19, isDonor: false },
  { id: 4, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '楼宇对讲门口机', time: '2026-07-06 10:44:12', duration: 18.26, isDonor: false },
  { id: 5, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '楼宇对讲门口机', time: '2026-07-06 11:05:10', duration: 18.25, isDonor: false },
  { id: 6, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '智慧中控屏', time: '2026-07-06 13:41:53', duration: 18.17, isDonor: false },
  { id: 7, company: '狄鸿智创产业科技（深圳）有限公司', type: '商用设备', product: '走廊屏', time: '2026-07-03 14:26:33', duration: 21.04, isDonor: false },
  { id: 8, company: '华为技术有限公司', type: '商用设备', product: 'OptiXstar P813L', time: '2026-07-16 20:34:26', duration: 7.85, isDonor: true },
  { id: 9, company: '金华英石物联科技有限公司', type: '商用设备', product: 'LED Driver Control', time: '2026-07-03 18:08:15', duration: 20.93, isDonor: false },
  { id: 10, company: '宁波麦思捷科技有限公司', type: '商用设备', product: 'MD', time: '2026-07-03 13:51:55', duration: 21.06, isDonor: false },
  { id: 11, company: '上海三思电子工程有限公司', type: '商用设备', product: '单灯控制器', time: '2026-07-15 16:11:36', duration: 8.98, isDonor: true },
  { id: 12, company: '深圳华龙讯达信息技术股份有限公司', type: '商用设备', product: '华龙一体机', time: '2026-07-03 16:26:01', duration: 21, isDonor: false },
  { id: 13, company: '深圳市威可达实业有限公司', type: '商用设备', product: '红外外部无线独立式感烟火灾探测报警器', time: '2026-07-16 16:06:41', duration: 7.99, isDonor: false },
  { id: 14, company: '深圳市华成峰达实业有限公司', type: '商用设备', product: '联网独立式感烟火灾探测报警器', time: '2026-07-16 16:04:21', duration: 8, isDonor: false },
  { id: 15, company: '深圳市海洋王照明工程有限公司', type: '商用设备', product: '防爆全景移动照明', time: '2026-07-07 18:05:39', duration: 17.94, isDonor: false },
  { id: 16, company: '深圳市浩然盈科通讯科技有限公司', type: '商用设备', product: 'HR-55', time: '2026-07-03 16:34:27', duration: 20.99, isDonor: false },
  { id: 17, company: '深圳市捷通科技有限公司', type: '商用设备', product: 'UHF4通道天读写器', time: '2026-07-04 14:44:08', duration: 20.02, isDonor: false },
  { id: 18, company: '深圳市云之声科技有限公司', type: '商用设备', product: 'WE-CON-4G41-HM', time: '2026-07-21 09:23:27', duration: 3.32, isDonor: false },
  { id: 19, company: '深圳市智联云网科技有限公司', type: '模组/开发板', product: '2.4G定位模组', time: '2026-07-17 17:27:56', duration: 6.97, isDonor: false },
  { id: 20, company: '深圳市逐浪数字科技有限公司', type: '模组/开发板', product: 'ING91680C主控板', time: '2026-07-17 17:52:33', duration: 6.95, isDonor: false },
  { id: 21, company: '深圳市烽烁讯科技有限公司', type: '商用设备', product: '智能安全帽', time: '2026-07-16 17:56:44', duration: 7.94, isDonor: false }
];

const potentialPartnerData = {
  categories: ['企业科技（深圳）有限...', '上海汉拓电子科技有限公司', '深圳华芯达信息技术股份有限...', '浙江图创智控技术有限公司', '星空航空测控股份有限公司', '北京神州图测科技有限公司', '乐鑫信息科技（上海）股份有限...', '深圳芯动联创科技有限公司'],
  values: [16, 12, 7, 7, 5, 5, 5, 5]
};

const initPotentialPartnerChart = () => {
  if (!potentialPartnerChartRef.value) return;
  if (potentialPartnerChartInstance) potentialPartnerChartInstance.dispose();
  potentialPartnerChartInstance = echarts.init(potentialPartnerChartRef.value);
  const option = {
    tooltip: { trigger: 'axis', formatter: '{b}: {c}' },
    legend: { data: ['提测数量'], bottom: 0, left: 0, textStyle: { color: '#475569', fontSize: 12 } },
    grid: { left: 50, right: 20, top: 20, bottom: 60 },
    xAxis: {
      type: 'category', data: potentialPartnerData.categories,
      axisLine: { lineStyle: { color: '#d9d9d9' } }, axisTick: { show: false },
      axisLabel: { color: '#8c8c8c', fontSize: 11, rotate: 30, interval: 0 }
    },
    yAxis: { type: 'value', max: 20, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: '#8c8c8c', fontSize: 11 }, splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } } },
    series: [{
      name: '提测数量', type: 'bar', data: potentialPartnerData.values, barWidth: '60%',
      itemStyle: { color: '#3b82f6', borderRadius: [4, 4, 0, 0] },
      label: { show: true, position: 'top', fontSize: 12, fontWeight: 600, color: '#374151' }
    }]
  };
  potentialPartnerChartInstance.setOption(option);
};

onMounted(() => {
  nextTick(() => { initPotentialPartnerChart(); });
  window.addEventListener('resize', () => { potentialPartnerChartInstance?.resize(); });
});
</script>

<style scoped>
.section { margin-bottom: 32px; }
.section-header { display: flex; align-items: center; gap: 14px; margin-bottom: 20px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; }
.section-number { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 8px; background: linear-gradient(135deg, #50A2FF 0%, #3B82F6 100%); color: #fff; font-size: 15px; font-weight: 700; flex-shrink: 0; box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3); }
.section-text { font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; }

.xts-row { display: flex; gap: 16px; }
.xts-row .xts-container { flex: 1; min-width: 0; }
.xts-row .potential-partner-container { flex: 1; min-width: 0; margin-top: 0; }
.xts-container { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; }
.xts-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.xts-header-left { display: flex; align-items: center; gap: 8px; }
.xts-header-icon { font-size: 18px; color: #52c41a; }
.xts-header-title { font-size: 16px; font-weight: 600; color: #1a1a2e; }
.xts-total-badge { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 8px 16px; font-size: 14px; color: #374151; }
.xts-total-value { font-size: 22px; font-weight: 700; color: #16a34a; margin: 0 4px; }
.xts-status-row { display: flex; gap: 16px; }
.xts-status-card { flex: 1; border-radius: 10px; overflow: hidden; border: 1px solid; }
.xts-status-certified { border-color: #86efac; } .xts-status-reviewing { border-color: #93c5fd; } .xts-status-pending { border-color: #fdba74; } .xts-status-rejected { border-color: #fca5a5; }
.xts-status-header { padding: 14px 16px; text-align: center; }
.xts-status-header-certified { background: #22c55e; } .xts-status-header-reviewing { background: #3b82f6; } .xts-status-header-pending { background: #f97316; } .xts-status-header-rejected { background: #ef4444; }
.xts-status-label { font-size: 14px; color: #fff; margin-bottom: 4px; }
.xts-status-count { font-size: 26px; font-weight: 700; color: #fff; }
.xts-status-unit { font-size: 13px; font-weight: 400; }
.xts-status-body { background: #fff; padding: 12px 16px; display: flex; flex-direction: column; gap: 8px; }
.xts-sub-item { display: flex; justify-content: space-between; align-items: center; padding: 6px 10px; background: #f9fafb; border-radius: 6px; font-size: 13px; color: #4b5563; }
.xts-sub-value { font-weight: 600; }
.xts-sub-value-certified { color: #16a34a; } .xts-sub-value-reviewing { color: #2563eb; } .xts-sub-value-pending { color: #ea580c; } .xts-sub-value-rejected { color: #dc2626; }

.potential-partner-container { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; margin-top: 16px; }
.potential-partner-title { font-size: 16px; font-weight: 600; color: #1a1a2e; text-align: center; margin-bottom: 16px; }
.potential-partner-chart { width: 100%; height: 360px; }

.xts-reject-container { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; margin-top: 16px; }
.xts-reject-header { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; }
.xts-reject-header-icon { font-size: 18px; color: #52c41a; }
.xts-reject-header-title { font-size: 16px; font-weight: 600; color: #1a1a2e; }
.xts-reject-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.xts-reject-table th { background: #f0fdf4; padding: 10px 12px; text-align: left; font-weight: 600; color: #374151; border-bottom: 2px solid #e5e7eb; }
.xts-reject-table td { padding: 10px 12px; border-bottom: 1px solid #f3f4f6; color: #4b5563; text-align: left; }
.xts-reject-table tbody tr:hover { background: #f9fafb; }

.section-summary { background: linear-gradient(135deg, #f0f7ff 0%, #f5f3ff 100%); border: 1px solid #c7d2fe; border-left: 4px solid #3b82f6; border-radius: 8px; padding: 20px 24px; margin-top: 16px; text-align: left; }
.section-summary-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #1e3a5f; margin-bottom: 12px; }
.section-summary-icon { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 6px; background: linear-gradient(135deg, #3b82f6, #6366f1); color: #fff; font-size: 14px; font-weight: 700; }
.section-summary p { font-size: 14px; line-height: 1.8; color: #374151; margin: 0; }
.xts-reject-table .xts-duration-high { color: #dc2626 !important; font-weight: 600; }
.xts-donor-yes { display: inline-block; padding: 2px 10px; border-radius: 10px; background: #f0fdf4; color: #16a34a; font-size: 12px; font-weight: 600; }
.xts-donor-no { display: inline-block; padding: 2px 10px; border-radius: 10px; background: #f9fafb; color: #9ca3af; font-size: 12px; }
</style>
